import { getApiErrorMessage } from "@api/apiError";
import {
    ScheduleMilestoneAlreadyRecognizedError,
    ScheduleMilestoneRefusedError,
} from "@api/scheduleErrors";
import { SCHEDULE_MILESTONE_RECOGNIZE_FAILED_MESSAGE } from "@api/scheduleMilestone.api";
import { ShowLockedPeriods } from "../useScheduleLockedPeriodsDialog";

export type MilestoneAchievedFailure =
    | { kind: "alreadyRecognized"; shouldClose: true }
    | { kind: "lockedPeriod"; shouldClose: true }
    | { kind: "refused"; shouldClose: true; message: string }
    | { kind: "failed"; shouldClose: false; message: string };

export function resolveMilestoneAchievedFailure(options: {
    error: unknown;
    /** Shows the locked-periods dialog when the error is one; a side effect. */
    showLockedPeriods: ShowLockedPeriods;
}): MilestoneAchievedFailure {
    const { error } = options;
    if (error instanceof ScheduleMilestoneAlreadyRecognizedError) {
        return { kind: "alreadyRecognized", shouldClose: true };
    }
    if (options.showLockedPeriods(error)) {
        return { kind: "lockedPeriod", shouldClose: true };
    }
    const message = getApiErrorMessage(
        error,
        SCHEDULE_MILESTONE_RECOGNIZE_FAILED_MESSAGE,
    );
    return error instanceof ScheduleMilestoneRefusedError
        ? { kind: "refused", shouldClose: true, message }
        : { kind: "failed", shouldClose: false, message };
}
